export const name = "WNRS x Bumble Bizz"
export const menu = "Bumble Bizz"
export const crossover = "Bumble Bizz"
export const suggestedPlayer = "2 players"
export const color = {
    primary: {
        main:  '#ee7547',
        contrastText: '#201e1f',
    },
    secondary: {
        main: '#201e1f',
    }
}
export const levels = ['Level 1 Perception', 'Level 2 Connection', 'Level 3 Reflection']
export const isExpansion = false

export const level1 = [
    "Do I seem like more of\n a creative or analytical\n type? Explain.",
    "How organized do you think\n my computer desktop is on\n a scale of 1-10?",
    "Between the two of us,\n who do you think is quicker\n at responding to emails?"
]

export const level2 = [
    "If funding weren't an\n issue, what idea would\n you execute this year?",
    "In the form of an\n elevator pitch, describe\n what you do for a living.",
    "What's the most\n important thing you're\n currently putting off?",
    "What are you better\n at than most people\n you know?",
    "What do you need most\n help with currently?",
    "What do you wish\n you could spend more\n time doing?",
    "What professional\n advice would you give\n your younger self?",
    "What was the most\n fulfilling moment of your\n career this past year?",
    "What career low has\n taught you the most?",
    "What part of your\n job leaves you most\n energized? And the\n most drained?",
    "Wild Card Both players write down\n your number one goal for\n the next month. Exchange."
]

export const level3 = [
    "How do our skillsets\n complement each other?",
    "Wild Card Write down a podcast\n your partner needs to\n listen to. Exchange.",
    "Wild Card Write a motivational\n reminder to your partner.\n Fold and exchange.\n Open when needed.\n (Both players.)",
]